var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Illustration/Illustration.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/Illustration/Illustration.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Illustration/Illustration.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("macros", t_4);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("social"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 3;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
context.getSuper(env, "title", b_title, frame, runtime, function(t_13,hole_11) {
if(t_13) { cb(t_13); return; }
hole_11 = runtime.markSafe(hole_11);
output += runtime.suppressValue(hole_11, env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 3, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Bang! Bang! • Иллюстрации"])), env.opts.autoescape);
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_social(env, context, frame, runtime, cb) {
var lineno = 4;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"ogImage") == "") {
output += "\n        <meta property=\"og:image\" content=\"";
output += runtime.suppressValue((lineno = 6, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/front/share.png"])), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:url\" content=\"";
output += runtime.suppressValue((lineno = 7, colno = 76, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"build_absolute_uri"), "request[\"build_absolute_uri\"]", context, [(lineno = 7, colno = 83, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/front/share.png"]))])), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:secure_url\" content=\"https://bangbangstudio.ru/static/img/front/share.png\"/>\n        <meta name=\"twitter:image\" content=\"https://bangbangstudio.ru/static/img/front/share.png\">\n    ";
;
}
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"ogImage") != "") {
output += "\n        <meta property=\"og:image\" content=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"ogImage"), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:url\" content=\"";
output += runtime.suppressValue((lineno = 13, colno = 76, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"build_absolute_uri"), "request[\"build_absolute_uri\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"ogImage")])), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:secure_url\" content=\"https://bangbangstudio.ru";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"ogImage"), env.opts.autoescape);
output += "\"/>\n        <meta name=\"twitter:image\" content=\"https://bangbangstudio.ru";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"ogImage"), env.opts.autoescape);
output += "\">\n    ";
;
}
output += "\n    <meta property=\"og:type\" content=\"website\"/>\n    <meta property=\"og:image:width\" content=\"1200\"/>\n    <meta property=\"og:image:height\" content=\"630\"/>\n    <meta property=\"og:image:type\" content=\"image/png\"/>\n    <meta property=\"og:url\" content=\"";
output += runtime.suppressValue((lineno = 21, colno = 66, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"build_absolute_uri"), "request[\"build_absolute_uri\"]", context, [])), env.opts.autoescape);
output += "\">\n    <meta name=\"twitter:card\" content=\"summary_large_image\"/>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 25;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"Illustration\">\n        ";
var t_14;
t_14 = "illustration";
frame.set("mods", t_14, true);
if(frame.topLevel) {
context.setVariable("mods", t_14);
}
if(frame.topLevel) {
context.addExport("mods", t_14);
}
output += "\n        ";
output += runtime.suppressValue((lineno = 28, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"includeComponent"), "macros[\"includeComponent\"]", context, ["front/components/Common/TopBar/TopBar.jinja",[],runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "mods"),"caller": (function (){var macro_t_15 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_16 = "";;
frame = frame.pop();
return new runtime.SafeString(t_16);
});
return macro_t_15;})()})])), env.opts.autoescape);
output += "\n\n        <div class=\"Illustration-title\">\n            ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"tokens");
if(t_19) {t_19 = runtime.fromIterator(t_19);
var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("token", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += "\n                ";
if(runtime.memberLookup((t_20),"type") == 1) {
output += "\n                    <a href=\"";
if(runtime.contextOrFrameLookup(context, frame, "language") == "en") {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "language"), env.opts.autoescape);
;
}
output += "/illustrations/search/?query=";
output += runtime.suppressValue(runtime.memberLookup((t_20),"slug"), env.opts.autoescape);
output += "\"><p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_20),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
output += "</p></a>\n                ";
;
}
output += "\n            ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n        <div class=\"Illustration-content\">\n            ";
output += runtime.suppressValue((lineno = 38, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"fullQuality"), "macros[\"fullQuality\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"image"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"illustrationId"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"altText"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_22 = "";;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
return macro_t_21;})()})])), env.opts.autoescape);
output += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"body")) {
output += "\n                <div class=\"Illustration-contentCaption\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"body")), env.opts.autoescape);
output += "</div>\n            ";
;
}
output += "\n            <div class=\"Illustration-contentTokens\">\n                ";
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"tokens");
if(t_25) {t_25 = runtime.fromIterator(t_25);
var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("token", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "\n                    ";
if(runtime.memberLookup((t_26),"type") != 1) {
output += "\n                        <a href=\"";
if(runtime.contextOrFrameLookup(context, frame, "language") == "en") {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "language"), env.opts.autoescape);
;
}
output += "/illustrations/search/?query=";
output += runtime.suppressValue(runtime.memberLookup((t_26),"slug"), env.opts.autoescape);
output += "\"><span>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") != 2) {
output += ", ";
;
}
output += "</span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_26),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
output += "</a>\n                    ";
;
}
output += "\n                ";
;
}
}
frame = frame.pop();
output += "\n            </div>\n        </div>\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "illustrations")) > 0) {
output += "\n            <div class=\"Illustration-jobs\">\n                <div class=\"Illustration-jobsTitle\">";
output += runtime.suppressValue((lineno = 52, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Другие работы"])), env.opts.autoescape);
output += "</div>\n                <div class=\"swiper-container jobs\">\n                    <div class=\"swiper-wrapper\">\n                        ";
frame = frame.push();
var t_29 = runtime.contextOrFrameLookup(context, frame, "illustrations");
if(t_29) {t_29 = runtime.fromIterator(t_29);
var t_28 = t_29.length;
for(var t_27=0; t_27 < t_29.length; t_27++) {
var t_30 = t_29[t_27];
frame.set("slider", t_30);
frame.set("loop.index", t_27 + 1);
frame.set("loop.index0", t_27);
frame.set("loop.revindex", t_28 - t_27);
frame.set("loop.revindex0", t_28 - t_27 - 1);
frame.set("loop.first", t_27 === 0);
frame.set("loop.last", t_27 === t_28 - 1);
frame.set("loop.length", t_28);
output += "\n                            <a href=\"/illustrations/illustration/";
output += runtime.suppressValue(runtime.memberLookup((t_30),"id"), env.opts.autoescape);
output += "\"\n                               class=\"swiper-slide ";
if(runtime.memberLookup((t_30),"illustrationType") == 1) {
output += "small";
;
}
if(runtime.memberLookup((t_30),"illustrationType") == 2) {
output += "medium";
;
}
if(runtime.memberLookup((t_30),"illustrationType") == 3) {
output += "large";
;
}
output += "\">\n                                ";
output += runtime.suppressValue((lineno = 58, colno = 54, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"image2x"), "macros[\"image2x\"]", context, [runtime.memberLookup((t_30),"image"),runtime.memberLookup((t_30),"isGif"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_31 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_32 = "";;
frame = frame.pop();
return new runtime.SafeString(t_32);
});
return macro_t_31;})()})])), env.opts.autoescape);
output += "</a>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n                <div class=\"swiper-button-next jobs\"></div>\n                <div class=\"swiper-button-prev jobs\"></div>\n            </div>\n        ";
;
}
output += "\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "more")) > 0) {
output += "\n            <div class=\"Illustration-suggestion\">\n                <div class=\"Illustration-suggestionTitle\">";
output += runtime.suppressValue((lineno = 68, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Еще"])), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moreTitle"), env.opts.autoescape);
output += "</div>\n                <div class=\"swiper-container suggestion\">\n                    <div class=\"swiper-wrapper\">\n                        ";
frame = frame.push();
var t_35 = runtime.contextOrFrameLookup(context, frame, "more");
if(t_35) {t_35 = runtime.fromIterator(t_35);
var t_34 = t_35.length;
for(var t_33=0; t_33 < t_35.length; t_33++) {
var t_36 = t_35[t_33];
frame.set("slider", t_36);
frame.set("loop.index", t_33 + 1);
frame.set("loop.index0", t_33);
frame.set("loop.revindex", t_34 - t_33);
frame.set("loop.revindex0", t_34 - t_33 - 1);
frame.set("loop.first", t_33 === 0);
frame.set("loop.last", t_33 === t_34 - 1);
frame.set("loop.length", t_34);
output += "\n                            <a href=\"/illustrations/illustration/";
output += runtime.suppressValue(runtime.memberLookup((t_36),"id"), env.opts.autoescape);
output += "\"\n                               class=\"swiper-slide ";
if(runtime.memberLookup((t_36),"illustrationType") == 1) {
output += "small";
;
}
if(runtime.memberLookup((t_36),"illustrationType") == 2) {
output += "medium";
;
}
if(runtime.memberLookup((t_36),"illustrationType") == 3) {
output += "large";
;
}
output += "\">\n                                ";
output += runtime.suppressValue((lineno = 74, colno = 54, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"image2x"), "macros[\"image2x\"]", context, [runtime.memberLookup((t_36),"image"),runtime.memberLookup((t_36),"isGif"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_37 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_38 = "";;
frame = frame.pop();
return new runtime.SafeString(t_38);
});
return macro_t_37;})()})])), env.opts.autoescape);
output += "</a>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n                <div class=\"swiper-button-next suggestion\"></div>\n                <div class=\"swiper-button-prev suggestion\"></div>\n            </div>\n        ";
;
}
output += "\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_social: b_social,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Illustration/Illustration.jinja"] , dependencies)